import React from "react";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { AddCircleRounded } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import DataList from "components/DataList";
import ShiftPositionItem from "./ShiftPositionItem";

const ShiftPositions = ({
  positions = [],
  onAddPosition,
  onPositionHandler,
  onRemovePosition,
  assignedStaff = [],
}) => {
  const theme = useTheme();

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px", color: "#212121" }}>
            Positions
          </Typography>
          <IconButton color="info" onClick={onAddPosition}>
            <AddCircleRounded />
          </IconButton>
        </Box>

        <Box>
          {positions.length > 0 ? (
            <DataList
              renderRow={(row, idx) =>
                ShiftPositionItem(row, idx, onPositionHandler, onRemovePosition, assignedStaff)
              }
              data={positions}
              greybar
              divider
              scrollY
              tableHeight={170}
              height={200}
              isLoading={false}
              noPadding
            />
          ) : (
            <Box sx={{ p: 3, textAlign: "center", color: theme.palette.text.secondary }}>
              <Typography variant="body2">
                No positions added. Click the + button to add a new position.
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ShiftPositions;
